import React, { useState, useEffect } from "react";
import Header from "../../Header/Header";
import Navbar from "../../Navbar/Navbar";
import Footer from "../../Footer/Footer";
import CareerHero from "../Hero/CareerHero";
import JobList from "../List/JobList";
import JobDetails from "../Details/JobDetails";
import "../Container/CareersContainer.css";
import { jsPDF } from 'jspdf';
import html2pdf from 'html2pdf.js';
import { Link } from 'react-router-dom';
import publicationsClient from '../../../lib/publicationsClient';

// Dynamic jobs loaded from backend

export default function CareersContainer() {
  const [jobs, setJobs] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeJobId, setActiveJobId] = useState(null);

  useEffect(()=> {
    (async ()=>{
      setLoading(true); setError(null);
      const list = await publicationsClient.listActive();
      // Map to expected shape for existing components
      const mapped = (list || []).map(p => ({
        id: p.id,
        title: p.title,
        description: (p.body || ''),
        endDate: p.endDate,
        category: p.category,
        publishedAt: p.publishedAt,
        location: p.location,
        contractType: p.contractType,
        attachments: p.attachments || []
      }));
      setJobs(mapped);
      setFiltered(mapped);
      setActiveJobId(mapped[0]?.id || null);
      setLoading(false);
    })();
  }, []);

    // Si HIDDEN_CATEGORIES n'est pas défini, on le définit ici
    const HIDDEN_CATEGORIES = React.useMemo(() => {
      const list = [
        "Apporteur d'affaire",
        'Apporteur d’affaire',
        "Developpeur d'application",
        "Développeur d'application",
        'Développeur d’application',
        'Developpeur d’application'
      ];
      const norm = (s) => (s||'').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu,'');
      return new Set(list.map(norm));
    }, []);

    const visibleCategories = React.useMemo(() => {
      const norm = (s) => (s||'').toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu,'');
      return Array.from(new Set(
        jobs
          .map(j => j.category)
          .filter(Boolean)
          .filter(c => !HIDDEN_CATEGORIES.has(norm(c)))
      ));
    }, [jobs, HIDDEN_CATEGORIES]);

    // Toutes les variables et hooks sont maintenant avant le rendu JSX
    // Place ici le return JSX
    return (
      <div className="careers-page">
        <main>
          <CareerHero />
          <div className="careers-wrap">
            <div className="careers-main">
              <div className="jobs-list">
                <JobList jobs={filtered} activeJobId={activeJobId} setActiveJobId={setActiveJobId} />
              </div>
              <div className="job-details-area">
                <JobDetails job={jobs.find(j => j.id === activeJobId)} />
                <div className="job-cta-panel">
                  {/* Bouton PDF export et bouton postuler, à adapter selon votre logique */}
                  <button
                    className="btn-secondary"
                    onClick={() => {
                      const container = document.createElement('div');
                      const style = [
                        ...Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map(link => `<link rel="stylesheet" href="${link.href}" />`),
                        `<style>${[...document.querySelectorAll('style')].map(s => s.innerHTML).join('\n')}</style>`
                      ].join('\n');
                      container.innerHTML = `
                        ${style}
                        <div class='careers-page careers-wrap job-details-area' style='padding:24px;font-family:Arial,sans-serif;'>
                          <h2 style='font-size:1.5rem;margin-bottom:12px;'>${jobs.find(j => j.id === activeJobId)?.title || ''}</h2>
                          ${jobs.find(j => j.id === activeJobId)?.description || ''}
                        </div>
                      `;
                      html2pdf().set({
                        margin: 10,
                        filename: `${(jobs.find(j => j.id === activeJobId)?.title || 'offre').replace(/\s+/g, '_')}.pdf`,
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' }
                      }).from(container).save();
                    }}
                  >
                    Télécharger PDF
                  </button>
                  <Link to="/apply" state={{ job: jobs.find(j => j.id === activeJobId) }} className="btn-primary" role="button">Postuler</Link>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
}
